import React, { useState, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useFetch } from '../../../components/hooks/useFetch';
import { Prefix } from '../../../services/prefix';
import './alerts.css';
import { Link } from 'react-router-dom';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { pt } from 'react-date-range/dist/locale';
import { useOnClickOutside } from '../../../components/hooks/useOnClickOutSide';

const FilterAlerts = ({
  startDate,
  setStartDate,
  unit,
  setUnit,
  sector,
  setSector,
  room,
  setRoom,
  serial,
  setSerial,
  alert,
  setAlert,
}) => {
  const [showDate, setShowDate] = useState(false);
  const ref = useRef(null);

  useOnClickOutside(ref, () => setShowDate(false));

  const resetFilter = () => {
    setStartDate([{ startDate: null, key: 'selection' }]);
    setUnit('');
    setSector('');
    setRoom('');
    setSerial('');
    setAlert('');
  };

  const baseUrl = Prefix.replace(/[\\"]/g, '');
  const listUnits = useFetch(`${baseUrl}/units`);
  const listSectors = useFetch(`${baseUrl}/sectors`);
  const listRooms = useFetch(`${baseUrl}/rooms`);
  const listItems = useFetch(`${baseUrl}/contract-items`);

  return (
    <Row>
      <Col>
        <div className="filterAlerts">
          {!showDate ? (
            <Link to="#" onClick={() => setShowDate(true)}>
              <i
                className="far fa-calendar-alt"
                style={{ fontSize: 18, marginRight: 10 }}
              />
            </Link>
          ) : (
            <div style={{ zIndex: 9999, position: 'absolute' }} ref={ref}>
              <DateRange
                editableDateInputs
                onChange={(item) => setStartDate([item.selection])}
                moveRangeOnFirstSelection={false}
                ranges={startDate}
                locale={pt}
              />
            </div>
          )}

          <select value={unit} onChange={(e) => setUnit(e.target.value)}>
            <option value="" disabled>
              Filtrar por unidade
            </option>
            {listUnits.data?.models.data.map((map) => (
              <option key={map.id} value={map.id}>
                {map.name}
              </option>
            ))}
          </select>

          {unit && (
            <select value={sector} onChange={(e) => setSector(e.target.value)}>
              <option value="" disabled>
                Filtrar por setor
              </option>
              {listSectors.data?.models.data.map((map) => (
                <option key={map.id} value={map.id}>
                  {map.name}
                </option>
              ))}
            </select>
          )}

          {sector && (
            <select value={room} onChange={(e) => setRoom(e.target.value)}>
              <option value="" disabled>
                Filtrar por sala
              </option>
              {listRooms.data?.models.data.map((map) => (
                <option key={map.id} value={map.id}>
                  {map.name}
                </option>
              ))}
            </select>
          )}

          <select value={serial} onChange={(e) => setSerial(e.target.value)}>
            {serial === '' ? (
              <option value="" disabled>
                Filtrar por serial
              </option>
            ) : (
              <option value="">Todos</option>
            )}
            {listItems.data?.models.data.map((map) => (
              <option key={map.serial} value={map.serial}>
                {map.serial}
              </option>
            ))}
          </select>

          <select value={alert} onChange={(e) => setAlert(e.target.value)}>
            {alert === '' ? (
              <option value="" disabled>
                Filtrar por tipo
              </option>
            ) : (
              <option value="">Todos</option>
            )}
            <option value="WARNING">Alerta amarelo</option>
            <option value="DANGER">Alerta vermelho</option>
          </select>

          <Link to="#" className="ml-4" onClick={resetFilter}>
            <i className="fas fa-undo-alt" />
          </Link>
        </div>
      </Col>
    </Row>
  );
};

export default FilterAlerts;
